import { render, staticRenderFns } from "./TileTotalVolume.vue?vue&type=template&id=4ed1340d"
import script from "./TileTotalVolume.vue?vue&type=script&lang=js"
export * from "./TileTotalVolume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports